"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletStepIntro = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const ButtonWithFooter_1 = require("../ButtonWithFooter");
const Detail_1 = require("./Detail");
const icons_1 = require("./icons");
const WalletStepIntro = ({ appName, appIcon, onContinue, }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(AppIconsWrapper, { children: (0, jsx_runtime_1.jsxs)(AppIcons, { children: [(0, jsx_runtime_1.jsx)(icons_1.SolanaIcon, {}, void 0), (0, jsx_runtime_1.jsx)(icons_1.ConnectDots, {}, void 0), appIcon] }, void 0) }, void 0), (0, jsx_runtime_1.jsxs)(Instruction, { children: ["To use ", appName, ", you need to connect a ", (0, jsx_runtime_1.jsx)("strong", { children: "Solana" }, void 0), " wallet."] }, void 0), (0, jsx_runtime_1.jsxs)(DetailsWrapper, { children: [(0, jsx_runtime_1.jsx)(Detail_1.Detail, { icon: (0, jsx_runtime_1.jsx)(icons_1.LockIcon, {}, void 0), title: "You control your crypto", description: "Using a non-custodial wallet enables you to control your crypto without having to trust third parties." }, void 0), (0, jsx_runtime_1.jsx)(Detail_1.Detail, { icon: (0, jsx_runtime_1.jsx)(icons_1.BoltIcon, {}, void 0), title: "Transact quickly and cheaply", description: "Solana's scalability ensures transactions remain less than $0.01 and at lightning fast speeds." }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(ButtonWithFooter_1.ButtonWithFooter, Object.assign({ onClick: onContinue, footer: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["First time using Solana?", " ", (0, jsx_runtime_1.jsx)("a", Object.assign({ href: "https://learn.goki.so", target: "_blank", rel: "noreferrer noopener" }, { children: "Learn more" }), void 0)] }, void 0) }, { children: "Continue" }), void 0)] }, void 0));
};
exports.WalletStepIntro = WalletStepIntro;
const Wrapper = styled_1.default.div `
  padding: 28px;
  padding-top: 33px;
`;
const AppIcons = styled_1.default.div `
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  grid-column-gap: 20px;
  align-items: center;
  width: 192px;
`;
const Instruction = styled_1.default.h2 `
  font-weight: normal;
  margin-top: 27px;
  font-size: 24px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #000000;
`;
const DetailsWrapper = styled_1.default.div `
  margin-top: 92px;
  display: grid;
  grid-row-gap: 28px;
`;
const AppIconsWrapper = styled_1.default.div `
  width: 100%;
  display: flex;
  justify-content: center;
`;
//# sourceMappingURL=index.js.map